module.exports = __webpack_public_path__ + "350012555a138bf8824739d7b32bc6c6.svg";